// Shared helper for fetching V2 suggestion chips and patching them onto a
// chat entry by id. Used by both pocContext (HTTP fallback path) and
// DataStreamingContext (WS finalize on V2 turns).
//
// Fire-and-forget: resolves silently to [] on any error so the caller never
// needs to handle rejection. The matching chat entry is patched by id once
// chips land. Pass the same reqId/traceId used for the parent call so the
// suggestions request correlates in console.

import { Dispatch, SetStateAction } from "react";
import { iChatData } from "../types";
import { chatPocSuggestionsApi } from "../api/poc-api/chatPocSuggestions";

interface FetchV2SuggestionsArgs {
  entryId: string;
  messages: any[];
  reqId: string;
  accessJWT: string;
  userId: string;
  setChatData: Dispatch<SetStateAction<iChatData[]>>;
}

export async function fetchAndStashV2Suggestions({
  entryId,
  messages,
  reqId,
  accessJWT,
  userId,
  setChatData,
}: FetchV2SuggestionsArgs): Promise<void> {
  try {
    const suggestions = await chatPocSuggestionsApi(
      accessJWT,
      {
        messages,
        userId,
        traceId: reqId,
      },
      undefined,
      reqId,
    );
    setChatData((prev: iChatData[]) =>
      prev.map((e) =>
        e.id === entryId ? { ...e, v2Suggestions: suggestions } : e,
      ),
    );
  } catch {
    // chatPocSuggestionsApi already returns [] on error; this catch is a
    // belt-and-braces guard so a thrown setState never bubbles up.
  }
}
